import script from "./ProjectList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectList.vue?vue&type=script&setup=true&lang=js"

import "./ProjectList.vue?vue&type=style&index=0&id=21724354&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21724354"]])

export default __exports__